var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportsExport = function SvgReportsExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -53.44,
    y1: 191.17,
    x2: 109.44,
    y2: 24.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -45.71,
    y1: 198.73,
    x2: 117.16,
    y2: 32.23,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -34,
    y1: 210.19,
    x2: 128.88,
    y2: 43.69,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -18.29,
    y1: 225.55,
    x2: 144.59,
    y2: 59.06,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -32.78,
    y1: 211.38,
    x2: 130.09,
    y2: 44.88,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M29.3,78.52h66.41c3.24,0,5.86-2.62,5.86-5.86s-2.62-5.86-5.86-5.86H29.3c-3.24,0-5.86,2.62-5.86,5.86s2.62,5.86,5.86,5.86Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3,101.95h50.78c3.24,0,5.86-2.62,5.86-5.86s-2.62-5.86-5.86-5.86H29.3c-3.24,0-5.86,2.62-5.86,5.86s2.62,5.86,5.86,5.86Z",
    style: {
      fill: "url(#c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3,125.39h50.78c3.24,0,5.86-2.62,5.86-5.86s-2.62-5.86-5.86-5.86H29.3c-3.24,0-5.86,2.62-5.86,5.86s2.62,5.86,5.86,5.86Z",
    style: {
      fill: "url(#d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7,137.11H29.3c-3.24,0-5.86,2.62-5.86,5.86s2.62,5.86,5.86,5.86h66.41c3.24,0,5.86-2.62,5.86-5.86s-2.62-5.86-5.86-5.86Z",
    style: {
      fill: "url(#e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.28,103.67l-23.44-23.44c-2.29-2.29-6-2.29-8.29,0-2.29,2.29-2.29,6,0,8.29l13.44,13.43h-27.65v-57.03c0-1.55-.62-3.04-1.72-4.14L111.57,1.72C110.47.62,108.98,0,107.42,0H21.48C9.64,0,0,9.64,0,21.48v157.03C0,190.36,9.64,200,21.48,200h109.37c11.85,0,21.48-9.64,21.48-21.48v-64.84h27.65l-13.44,13.44c-2.29,2.29-2.29,6,0,8.29,1.14,1.14,2.64,1.72,4.14,1.72s3-.57,4.14-1.72l23.44-23.44c2.29-2.29,2.29-6,0-8.29h0ZM132.34,39.06h-19.06v-19.06l19.06,19.06ZM140.62,178.52c0,5.38-4.38,9.77-9.77,9.77H21.48c-5.38,0-9.77-4.38-9.77-9.77V21.48c0-5.38,4.38-9.77,9.77-9.77h80.08v33.2c0,3.24,2.62,5.86,5.86,5.86h33.2v51.17h-40.23c-3.24,0-5.86,2.62-5.86,5.86s2.62,5.86,5.86,5.86h40.23v64.84Z",
    style: {
      fill: "url(#f)",
      strokeWidth: 0
    }
  }));
};
export default SvgReportsExport;